module.exports = __webpack_public_path__ + "img/delete.38228b1e.svg";